import type { Container } from '@/types/domain';

// Règle de visibilité de la migration 0029, côté client.
//
// Un espace sans groupe Microsoft 365 n'a pas de bibliothèque de documents où
// écrire : l'utilisateur ne le voit pas et ne peut pas y ranger. La règle est
// appliquée AU SERVEUR — outlook-list-containers et outlook-list-favorites
// filtrent, fn_search filtre dans sa CTE `acc`, et les endpoints atteignables par
// id refusent en 409 via assertContainerListable.
//
// Ce prédicat n'est donc PAS la garde : c'est la même règle, écrite une fois, pour
// les sélecteurs qui mènent à une ÉCRITURE (ranger, copier, déplacer vers un autre
// espace). Il évite qu'un cache TanStack encore chaud ne propose une destination
// que le serveur refusera par un 409 — un refus juste, mais incompréhensible pour
// quelqu'un qui vient de choisir l'espace dans une liste.
//
// Le garder ici plutôt que dupliqué dans les trois sélecteurs donne un seul
// endroit à corriger, et un endroit à tester.

export function isListableContainer(c: Container): boolean {
  return c.m365GroupId !== null && c.m365GroupId !== undefined;
}

/**
 * Filtre une liste d'espaces destinée à un sélecteur de destination.
 *
 * Rend le tableau d'ENTRÉE inchangé quand rien n'est à retirer : les trois
 * sélecteurs mémoïsent sur cette valeur, et fabriquer un tableau neuf à chaque
 * rendu invaliderait en cascade les `useMemo` qui en dépendent — le défaut que
 * corrige déjà le commentaire de DestinationPicker.tsx:125-127.
 */
export function filterListableContainers(list: readonly Container[]): readonly Container[] {
  return list.every(isListableContainer) ? list : list.filter(isListableContainer);
}
